/**
 * Returns the add subscription modal state.
 *
 * @param {Object} state Application state.
 *
 * @returns {Object} The add subscription modal state.
 */
export function getAddSubscriptionModal( state ) {
	return state.ui.addSubscriptionModal;
}

/**
 * Returns the subscription requesting state.
 *
 * @param {Object} state Application state.
 *
 * @returns {boolean} The subscription requesting state.
 */
export function isRequestingSubscriptions( state ) {
	return state.ui.subscriptions.requesting;
}


/**
 * The ui state for the subscription cancel modal.
 *
 * @param   {Object} state The application state.
 * @returns {Object}       An object containing relevant ui information for the subscription cancel modal.
 */
export const getCancelSubscriptionState = ( state ) => {
	return {
		cancelLoading: state.ui.subscriptionsCancel.loading,
		cancelSuccess: state.ui.subscriptionsCancel.success,
		cancelError: state.ui.subscriptionsCancel.error,
	};
};
